import { TranslateService } from '@ngx-translate/core';

const HOUR_COUNT_KEYS: Record<number, string> = { 1: '1', 2: '2' };

export const translateSessionTimeout = (
  translate: TranslateService,
  totalMinutes: number
): string => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = String(totalMinutes % 60).padStart(2, '0');

  if (hours === 0) {
    return translate.instant(
      'WEB_COMMUNITY_COMMUNITYTIMEOUT_DURATION_MINUTES',
      {
        minutes,
      }
    );
  }

  const hourCountKey = HOUR_COUNT_KEYS[hours] ?? 'N';
  const minutesKey = minutes === '00' ? '' : '_MINUTES';

  return translate.instant(
    `WEB_COMMUNITY_COMMUNITYTIMEOUT_DURATION_HOURS_${hourCountKey}${minutesKey}`,
    { hours, minutes }
  );
};
